"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/utils";
import { LogoTile } from "@/components/cards/logo-tile";
import type { ResourceCardProps } from "./resource-card.types";
export function ResourceCard(t0) {
  const $ = _c(17);
  const {
    title,
    href,
    logoLight,
    description,
    className
  } = t0;
  if (!href) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cn("group flex flex-col items-start gap-3 desktop:gap-4", "focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-border-active", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== logoLight || $[3] !== title) {
    t2 = <LogoTile logo={logoLight} alt={title} />;
    $[2] = logoLight;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== title) {
    t3 = title && <h3 className="typography-component-sm-medium text-text-primary desktop:typography-component-md-medium">{title}</h3>;
    $[5] = title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== description) {
    t4 = description && <p className="typography-body-sm-regular line-clamp-3 text-text-secondary">{description}</p>;
    $[7] = description;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="flex w-full flex-col gap-2">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== href || $[13] !== t1 || $[14] !== t2 || $[15] !== t5) {
    t6 = <a href={href} target="_blank" rel="noopener noreferrer" data-testid="resource-card" className={t1}>{t2}{t5}</a>;
    $[12] = href;
    $[13] = t1;
    $[14] = t2;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}